import { render, staticRenderFns } from "./TheBottomNavigation.vue?vue&type=template&id=31ab760c&"
import script from "./TheBottomNavigation.vue?vue&type=script&lang=js&"
export * from "./TheBottomNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports